import React from 'react';
import { useT } from '@repo/common';
import { emptyRow } from './policyNoticeForm';
import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/16px/icon_16px_plus_outline.svg';
import { ReactComponent as DeleteIcon } from '@repo/common/assets/icons/16px/icon_16px_delete_outline.svg';

// 한/영 병기 항목 목록 입력 (개정 사유·변경 사항)
const TEXTAREA_CLASS =
  'w-full rounded-[8px] border border-grayscale-gray02 bg-grayscale-gray00 px-[12px] py-[8px] typo-b14 text-text-primary placeholder:text-text-placeholder focus:outline-none focus:border-grayscale-gray04 resize-y disabled:bg-grayscale-gray01';

const BilingualListField = ({ label, rows, onChange, placeholder }) => {
  const t = useT();

  const updateRow = (index, key, value) =>
    onChange(rows.map((row, i) => (i === index ? { ...row, [key]: value } : row)));

  const removeRow = (index) => {
    const next = rows.filter((_, i) => i !== index);
    onChange(next.length > 0 ? next : [emptyRow()]);
  };

  return (
    <div className='flex flex-col gap-[8px]'>
      <span className='typo-b13Strong text-text-secondary'>{label}</span>

      {rows.map((row, index) => (
        <div
          key={index}
          className='flex gap-[8px] items-start rounded-[10px] border border-grayscale-gray02 bg-grayscale-gray01 p-[10px]'
        >
          <span className='typo-b12Strong text-text-placeholder pt-[10px] w-[16px] shrink-0 text-center'>
            {index + 1}
          </span>
          <div className='flex flex-col gap-[6px] flex-1 min-w-0'>
            <textarea
              rows={2}
              value={row.ko}
              onChange={(e) => updateRow(index, 'ko', e.target.value)}
              placeholder={`${t('Korean', '한국어')} · ${placeholder?.ko ?? ''}`}
              className={TEXTAREA_CLASS}
            />
            <textarea
              rows={2}
              value={row.en}
              onChange={(e) => updateRow(index, 'en', e.target.value)}
              placeholder={`${t('English', '영어')} · ${placeholder?.en ?? ''}`}
              className={TEXTAREA_CLASS}
            />
          </div>
          <button
            type='button'
            onClick={() => removeRow(index)}
            aria-label={t('Remove line', '항목 삭제')}
            className='mt-[8px] p-[4px] rounded-[6px] text-icon-secondary hover:bg-grayscale-gray02 disabled:opacity-40'
          >
            <DeleteIcon />
          </button>
        </div>
      ))}

      <button
        type='button'
        onClick={() => onChange([...rows, emptyRow()])}
        className='self-start flex items-center gap-[4px] px-[8px] py-[6px] rounded-[6px] typo-b13Strong text-text-secondary hover:bg-grayscale-gray02 disabled:opacity-40'
      >
        <PlusIcon />
        {t('Add line', '항목 추가')}
      </button>
    </div>
  );
};

export default BilingualListField;
